export const TIDS = {
    nav: {
        logo: "nav-logo",
        home: "nav-home",
        about: "nav-about",
        mass: "nav-mass",
        groups: "nav-groups",
        scc: "nav-scc",
        live: "nav-live",
        gallery: "nav-gallery",
        prayer: "nav-prayer",
        contact: "nav-contact",
        menuToggle: "nav-menu-toggle",
    },
    home: {
        hero: "home-hero",
        ctaJoinMass: "home-cta-mass",
        ctaWatchLive: "home-cta-live",
        ctaPrayerWall: "home-cta-prayer",
        massTimes: "home-mass-times",
        spiritualHub: "home-spiritual-hub",
        verseCard: "home-verse-card",
        saintCard: "home-saint-card",
        seasonBanner: "home-season-banner",
        readingsLink: "home-readings-link",
    },
    prayer: {
        form: "prayer-form",
        name: "prayer-name",
        intention: "prayer-intention",
        submit: "prayer-submit",
        list: "prayer-list",
        prayBtn: (id) => `prayer-pray-${id}`,
    },
    live: {
        youtubeEmbed: "live-youtube",
        facebookEmbed: "live-facebook",
        loadYoutube: "live-load-youtube",
        loadFacebook: "live-load-facebook",
    },
    groups: {
        section: "groups-section",
    },
    scc: {
        grid: "scc-grid",
    },
};
